export const enum Links {
  Home = '/', // Flows visualization
  SourceCode = '/code', // Flows source code
  DataMapper = '/datamapper',
  About = '/about',
  Beans = '/beans',
  RestImport = '/rest/import',
  RestEditor = '/rest',
  Metadata = '/metadata',
  PipeErrorHandler = '/pipe-error-handler',
  Catalog = '/catalog',
  Settings = '/settings',
}

export const enum ExternalLinks {
  GitHub = 'https://github.com/KaotoIO/kaoto',
}
